import { render } from "./DashboardLayout.vue?vue&type=template&id=2a5352c6"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"

import "./DashboardLayout.vue?vue&type=style&index=0&id=2a5352c6&lang=scss"
script.render = render

export default script